// Auth
export const AUTH_GET_INFO_URL = 'v2/user/info';
export const AUTH_GET_FEATURES_URL = 'v2/auth/features';
export const AUTH_POST_LOGIN_URL = 'v2/auth/login';
export const AUTH_VERIFY_EMAIL = 'v2/auth/verify-email';
export const AUTH_SET_PASSWORD = 'v2/auth/set-password';
export const AUTH_POST_LOGOUT_URL = 'v2/auth/logout';
export const AUTH_POST_REGISTER_URL = 'v2/auth/register';
export const AUTH_UPDATE_MOBILE = 'v2/user/update-mobile';
export const AUTH_POST_PASSWORD_RESET_LINK = 'v2/auth/password-reset-link';
export const AUTH_POST_PASSWORD_RESET_VERIFY = 'v2/auth/password-reset-verify';
export const AUTH_POST_PASSWORD_RESET = 'v2/auth/password-reset';
export const AUTH_POST_LOGIN_WITH_GOOGLE = '/sso/google/login';
export const STORE_SWITCH = 'v2/user/switch-store';
export const SAVE_STORE_SELECTED_SP_BRANDS = 'v2/store/select/sp/brands';

// Organization
export const GET_ORG_USERS = 'v2/org/users';
export const ORG_CREATE_NEW_USER = 'v2/org/users';
export const GET_USER_BY_ID = 'v2/org/users/{userId}';
export const ORG_UPDATE_USER = 'v2/org/users/{userId}';
export const ORG_STORE_ADD_USER_ACCESS = 'v2/org/users/{userId}/add-stores';
export const ORG_STORE_REMOVE_USER_ACCESS = 'v2/org/users/{userId}/remove-stores';
export const UPDATE_USER_DETAILS = 'v2/user/update';

// agency
export const GET_AGENCY_DETAILS = 'v2/org/agency';
export const UPDATE_AGENCY_DETAILS = 'v2/org/agency';

// Roles
export const GET_ORG_ROLES_PERMISSIONS = '/v2/org/roles/permissions';
export const GET_ALL_ORG_ROLES = 'v2/org/roles';
export const CREATE_NEW_ROLE = 'v2/org/roles';
export const UPDATE_ROLE = 'v2/org/roles';

// store
export const GET_ALL_STORE = 'v2/user/stores';
export const GET_USER_STORE_REPORT = 'v2/growz/reports/users-stores-report';
export const GET_USER_STORE_ANALYSIS = 'v2/growz/reports/users-store-analysis';
export const GET_STORE_DAILY_TARGETS = 'v2/store/details';
export const GET_STORE_PORTFOLIOS = 'v2/store/portfolios';
export const DELETE_STORE = 'v2/org/stores/{storeId}';
export const UPDATE_CUSTOM_NAME = 'v2/store/custom-name';
export const UPDATE_STORE_DETAILS = 'v2/store/update';
export const STORE_PAUSE_OP = 'v2/org/stores/{storeId}/pause';
export const STORE_RESUME_OP = 'v2/org/stores/{storeId}/resume';
export const STORE_REQUEST_DELETE = 'v2/org/stores/{storeId}/request-delete';
export const STORE_UPDATE_GLOBAL_SETTINGS = 'v2/store/global-settings';

// onboarding
export const ONBOARDING_GET_DETAILS = 'v2/onboarding';
export const ONBOARDING_GET_MARKETPLACES = 'v2/onboarding/marketplaces';
export const ONBOARDING_GET_ADS_SYNC_PROGRESS = 'v2/onboarding/ad-progress';
export const ONBOARDING_POST_PROFILES = 'v2/onboarding/profiles';
export const ONBOARDING_POST_FINISH = 'v2/onboarding/finish';
export const ONBOARDING_SEND_EMAIL = 'v2/auth/send/login/link';
export const ONBOARDING_CHECKLIST = 'v2/store/checklist/{name}';
export const ONBOARDING_UPDATE_CHECKLIST = 'v2/store/checklist/{name}/{key}/complete';

// Dashboard
export const GROWZ_GET_DASHBOARD = 'v1/growz/dashboard/widgets';
export const GROWZ_GET_ORDER_CLOCK_DATA = 'v2/growz/orders/order-clock';
export const GOALSTATUS = 'v1/growz/microgoals/goal/widget-count';
export const ADSPENDSALES = 'v1/growz/dashboard/calculate-keywords-spend';
export const GROWZ_TODAYS_REPORT = 'v2/growz/campaigns/todays/report/summary';
export const GROWZ_BUDGET_REPORT = 'v2/growz/reports/campaign-budget-util';
export const GROWZ_GROWTH_READINESS_REPORT = 'v2/growz/reports/growth-readiness-report';
export const GROWZ_BEST_BRAND_STORE = 'v2/growz/reports/best-brand-store';
export const GROWZ_DAILY_ORDER_SUMMARY = 'v2/growz/reports/daily-order-summary';

// Analytics
export const GROWZ_OVERVIEW_ANALYTICS = 'v2/growz/campaigns/report/summary';
export const GROWZ_PERFORMANCE_STATS = 'v2/growz/campaigns/performance/stats';

// Products
export const ALL_PRODUCTS = 'v1/products/all';
export const GET_ALL_PRODUCTS = 'v2/growz/products/list';
export const GROWZ_PUT_SP_PRODUCTAD_UPDATE = '/v1/growz/productad/sp/update';
export const GROWZ_GET_PRODUCT_BY_ASIN = '/v2/products/view/{asin}';
export const GROWZ_GET_PRODUCTS_SUMMARY = '/v2/growz/productad/summary';
export const GROWZ_GET_PRODUCTS_ASIN_SUMMARY = 'v2/growz/asin-analyzer/asin/ad/structure';

// Campaigns
export const GROWZ_GET_ALL_CAMPAIGNS = 'v1/growz/campaigns';
export const GROWZ_GET_ALL_CAMPAIGNS_NEW = 'v1/growz/campaigns/report/all';
export const GROWZ_GET_ALL_CAMPAIGNS_WIDGETS = 'v1/growz/campaigns/widgets';
export const GROWZ_GET_ALL_CAMPAIGNS_WITH_FILTERS = 'v1/growz/campaigns/filter';
export const GROWZ_GET_CAMPAIGN_BY_ID = 'v1/growz/campaigns/new/{campaignId}/page/view';
export const GROWZ_GET_ADGROUP_BY_ID = 'v1/growz/campaigns/adgroup/{adGroupId}/page/view';
export const GROWZ_GET_ADGROUP_TARGETS = 'v1/growz/campaigns/adgroup/{adGroupId}/targets';
export const GROWZ_GET_ADGROUP_SEARCH_TERMS = 'v1/growz/campaigns/adgroup/{adGroupId}/search/terms';
export const GROWZ_PUT_SP_CAMPAIGN_UPDATE = 'v1/growz/campaigns/{campaignType}/update';
export const GROWZ_ANALYZE_CAMPAIGN = 'v1/growz/campaigns/{campaignId}/analyze';
export const GET_ADGROUP_ANALYSIS = 'v2/growz/adgroups/analysis';
export const GROWZ_CAMPAIGN_BUDGET_UPDATE = 'v2/growz/campaigns/{campaignType}/update-budget';
export const GROWZ_PATCH_EDIT_CAMPAIGN = 'v2/growz/campaigns/{campaignId}/edit';
export const GROWZ_CAMPAIGN_NEGATIVE_KEYWORDS = 'v2/growz/campaigns/{campaignId}/negative/keywords';
export const GROWZ_CAMPAIGN_NEGATIVE_TARGETS = 'v2/growz/campaigns/{campaignId}/negative/targets';
export const GROWZ_POST_CAMPAIGN_LAUNCH_TEMPLATE = 'v2/growz/campaign-launcher';
export const GROWZ_PUT_ADGROUP_UPDATE = 'v1/growz/adgroups/{campaignType}/update';

// Reports
export const GROWZ_TOP_PERFORMING_KEYWORDS_REPORT = 'v2/growz/reports/analytics-topPerformingkeywords-report';
export const GROWZ_TOP_CAMPAIGN_REPORT = 'v2/growz/reports/campaign-report';
export const GROWZ_KEYWORD_TYPE_REPORT = 'v2/growz/reports/analytics-keywordmatchtype-report';
export const GROWZ_ADS_PERFORMANCE_TREND_REPORT = 'v2/growz/reports/ad-performance-trend-report';
export const GROWZ_STORE_KEYWORDS_REPORT = 'v2/growz/reports/store-keyword-report';
export const GROWZ_STORE_TARGETS_REPORT = 'v2/growz/reports/store-target-report';
export const GROWZ_STORE_SEARCH_TERM_REPORT = 'v2/growz/reports/store-searchterm-report';
export const GROWZ_STORE_PRODUCTAD_REPORT = 'v2/growz/reports/store-productad-report';
export const GROWZ_STORE_PRODUCTAD_BY_ASIN_REPORT = 'v2/growz/reports/store-productad-by-asin-report';
export const GROWZ_STORE_CAMPAIGN_REPORT = 'v2/growz/reports/store-campaign-report';
export const GROWZ_STORE_CAMPAIGN_PLACEMENT_REPORT = 'v2/growz/reports/store-placement-report';
export const GROWZ_STORE_BRAND_METRICS_REPORT = 'v2/growz/reports/brand-metrics-report';
export const GROWZ_TOP_ASINS_REPORT = 'v2/growz/reports/top-performing-asin';
export const GROWZ_ADV_HALO_CONVERSION_REPORT = 'v2/growz/reports/store-purchased-report';
export const GROWZ_STORE_BRAND_METRICS_CATEGORY_REPORT = 'v2/growz/reports/brand-metrics-category-report';
export const GROWZ_STORE_KEYWORD_TARGET_ASIN_REPORT = 'v2/growz/reports/target-keyword-asin-report';

// bulk
export const GROWZ_BULK_UPDATE = 'v2/growz/campaigns/attribute/{type}/bulk/update';
export const GROWZ_BULK_UPDATE_MATCH_TYPE = 'v2/growz/campaigns/attribute/{type}/bulk/update-create';
export const GROWZ_AUTOPILOT_BULK_UPDATE = 'v2/growz/campaigns/autopilot/bulk';
export const GROWZ_AUTOPILOT_BULK_DEACTIVATE = 'v2/growz/campaigns/autopilot/bulk/update';
export const GROWZ_BULK_ARCHIVED_CAMPAIGNS = 'v2/growz/campaigns/archived/campaigns';
// export const GROWZ_ADGROUPS_BULK_UPDATE = 'v2/growz/campaigns/attribute/adGroups/bulk/update';
// export const GROWZ_CAMPAIGNS_BULK_UPDATE = 'v2/growz/campaigns/attribute/campaigns/bulk/update';
// export const GROWZ_NEGATIVE_TARGETS_BULK_UPDATE = 'v2/growz/campaigns/attribute/negativeTargets/bulk/update';
// export const GROWZ_NEGATIVE_KEYWORDS_BULK_UPDATE = 'v2/growz/campaigns/attribute/negativeKeywords/bulk/update';
// export const GROWZ_TARGETS_STATE_BULK_UPDATE = 'v2/growz/campaigns/attribute/targets/bulk/update';
// export const GROWZ_PRODUCTADS_BULK_UPDATE = 'v2/growz/campaigns/attribute/productAds/bulk/update ';

// Autopilot
export const GROWZ_GET_AUTOPILOT_REPORTS = 'v2/growz/campaigns/{campaignId}/autopilot';

// Adgroups
export const GROWZ_GET_ALL_ADGROUPS = 'v1/growz/adgroups/list/all';
export const GROW_GET_ADGROUP_OPTIMIZED_BID = 'v1/growz/adgroups/{adGroupId}/target/optimized/bid';
export const GROW_GET_ADGROUP_KEYWORD_SCOUT_VIEW = 'v1/growz/adgroups/keyword/scout/{scoutId}/view';
export const GET_LAUNCHED_GOALS_FOR_ADGROUP = 'v1/growz/adgroups/{adGroupId}/launched/goals';
export const GET_CAMPAIGN_ANALYSIS_SINGLE = 'v2/growz/campaigns/analysis';
export const GROWZ_POST_MANUAL_KEYWORDS = 'v1/growz/keywords/{campaignType}/create';
export const GROWZ_POST_MANUAL_TARGETS = 'v1/growz/targets/{campaignType}/create';
export const GROWZ_GET_ADGROUP_HISTORY = 'v1/growz/campaigns/adgroup/{adGroupId}/history';
export const GROWZ_GET_ADGROUP_STRATEGY_BIDDING_DETAILS = 'v2/growz/adgroups/{adGroupId}/bid/strategy';
export const GROWZ_ADGROUP_NEGATIVE_KEYWORDS = 'v2/growz/adgroups/{adGroupId}/negative/keywords';
export const GROWZ_ADGROUP_NEGATIVE_TARGETS = 'v2/growz/adgroups/{adGroupId}/negative/targets';
export const GROWZ_POST_ADGROUP_NEGATIVE_KEYWORDS = 'v2/growz/campaigns/adgroup/{adGroupId}/negative/keywords';
export const GROWZ_POST_ADGROUP_NEGATIVE_TARGETS = 'v2/growz/campaigns/adgroup/{adGroupId}/negative/targets';
export const GROWZ_POST_CAMPAIGN_NEGATIVE_KEYWORDS = 'v2/growz/campaigns/{campaignId}/negative/keywords';
export const GROWZ_POST_CAMPAIGN_NEGATIVE_TARGETS = 'v2/growz/campaigns/{campaignId}/negative/targets';
export const GROWZ_POST_MANUAL_ADGROUP = 'v1/growz/adgroups/{campaignType}/create';

// keyword research
export const GROW_GET_ADGROUP_KEYWORD_SCOUT = 'v1/growz/adgroups/keyword/scout';
export const GROW_GET_KEYWORD_SCOUT_BY_ID = 'v1/growz/adgroups/keyword/scout/{scoutId}/view';
export const GROW_POST_ADGROUP_KEYWORD_SCOUT = 'v1/growz/adgroups/keyword/scout';
export const GROW_POST_KEYWORD_SCOUT_ADD_SELECTED = 'v2/growz/keyword-research/keyword/research/add/selected/keywords';
export const GROW_DELETE_ADGROUP_KEYWORD_SCOUT = 'v1/growz/adgroups/keyword/scout';
export const GROWZ_GET_KEYWORD_MARKETPLACE = 'v2/growz/keyword-research/get/keyword/research/marketplaces';

// reserve asin
export const GROW_POST_ASIN_RESEARCH = 'v2/growz/keyword-research/reverse/asin';
export const GROWZ_GET_ASIN_MARKETPLACE = 'v2/growz/keyword-research/get/asin/research/marketplaces';
export const GROW_GET_ASIN_RESEARCHES = 'v2/growz/keyword-research/get/reverse/asin/researches';

// Keywords
export const GROWZ_POST_KEYWORDS_CREATE = 'v1/growz/keywords/{campaignType}/create';
export const GROWZ_PUT_SP_KEYWORDS_UPDATE = 'v1/growz/keywords/sp/update';

// targets
export const UPDATE_SP_TARGETING_CLAUSE = 'v1/growz/targets/sp/update';
export const UPDATE_SD_TARGETING_CLAUSE = 'v1/growz/targets/sd/update';
export const UPDATE_SB_TARGETING_CLAUSE = 'v1/growz/targets/sb/update';
export const UPDATE_SP_KEYWORD = 'v1/growz/keywords/sp/update';

// microgoals
export const GROWZ_GET_ALL_GOALS = '/v1/growz/microgoals';
export const GROWZ_GET_CHAINED_GOALS = 'v1/growz/microgoals/get/{campaignId}/goals';
export const GROWZ_GET_ALL_GOALS_NEW = 'v1/growz/microgoals/all';
export const GROWZ_GET_LAUNCHED_GOALS_NEW = 'v1/growz/microgoals/launched';
export const GROWZ_GET_MICROGOAL_ACTIVITY = 'v1/growz/microgoals/goal/{sellerMicroGoalId}/activity';
export const GROWZ_MICROGOAL_RELATED_CAMPAIGNS = 'growz/microgoals/goal/{sellerMicroGoalId}/activity/related/campaigns';
export const GROWZ_GET_RECOMMENDED_GOALS = 'v1/growz/microgoals/recommended?campaignType={campaignType}';
export const GROWZ_GET_GOAL_BY_ID = 'v1/growz/microgoals/{goalId}/view';
export const GROWZ_GET_GOAL_BY_SLUG = 'v1/growz/microgoals/slug/{goalSlug}/view';
export const GROWZ_POST_GOAL_LAUNCH = 'v1/growz/microgoals/launch';
export const GROWZ_POST_GOAL_UPDATE = 'v1/growz/microgoals/goal/{sellermicrogoalid}/update-goal';
export const GROWZ_PUT_GOAL_UNLAUNCH = 'v1/growz/microgoals/goal/{sellerMicroGoalId}/unlaunch';
export const GROWZ_PUT_GOAL_RESUME = 'v1/growz/microgoals/goal/{sellerMicroGoalId}/resume';
export const GROWZ_MICROGOALS_CAMPAGIN_REVENUE = 'v1/growz/microgoals/goal/{sellerMicroGoalId}/camapign-revenue?days={days}';
export const GROWZ_MICROGOALS_KEYWORDS_SALES = 'v1/growz/campaigns/{campaignId}/keywords/data';
export const GROWZ_MICROGOALS_TARGET_SALES = 'v1/growz/campaigns/{campaignId}/targets/data';
export const GROWZ_MICROGOALS_CAMPAIGNS_FULL_REPORT = 'v1/growz/campaigns/full/report?noOfDays={days}';
export const GROWZ_MICROGOALS_ADGROUPS_FULL_REPORT = 'v1/growz/adgroups/full/report?noOfDays={days}';
export const GROWZ_SELLER_MICROGOAL_STORAGE_DATA = 'v1/growz/microgoals/goal/{sellerMicroGoalId}/storage';
export const GROWZ_MICROGOALS_DERIVED_DEFAULTS = 'v2/growz/microgoals/derived/defaults';
export const GROWZ_MICROGOALS_REVERT_ADDED_NEGATIVES = 'v2/growz/microgoals/revert/added/negatives';

// strategy
export const GROWZ_GET_STRATEGIES_BY_ID = 'v2/growz/microgoals/{goalId}';
export const GROWZ_GET_STRATEGIES_BY_ASIN = 'v2/growz/microgoals/search/{asin}';

// microgoal activity
export const GROWZ_MICROGOALS_ACTIVITY = 'v1/growz/microgoals/goal/{sellerMicroGoalIdParam}/activity';
export const GROWZ_MICROGOALS_RELATED_DATA = 'v1/growz/microgoals/goal/{sellerMicroGoalIdParam}/activity/related/data';
export const GROWZ_MICROGOALS_UPDATE_GOAL = 'v1/growz/microgoals/goal/{sellerMicroGoalIdParam}/update';
export const GROWZ_MICROGOALS_UPDATE_GOAL_BUDGET = 'v1/growz/microgoals/goal/{sellerMicroGoalIdParam}/update-goal';
export const GROWZ_MICROGOALS_UNLAUNCH_GOAL = 'v1/growz/microgoals/goal/{sellerMicroGoalIdParam}/unlaunch';
export const GROWZ_MICROGOALS_DELETE_GOAL = 'v1/growz/microgoals/goal/{sellerMicroGoalIdParam}/delete';
export const GROWZ_MICROGOALS_UPDATE_BID_TYPE = 'v1/growz/microgoals/goal/{sellerMicroGoalIdParam}/update-bid-type';
export const GROWZ_MICROGOALS_UPDATE_KEYWORDS = 'v1/growz/keywords/sp/create';
export const GROWZ_MICROGOALS_PRODUCT_REVIEWS = 'v1/growz/microgoals/goal/{sellerMicroGoalId}/product-reviews';
export const GROWZ_MICROGOALS_PRODUCT_CONVERSIONS = 'v1/growz/microgoals/goal/{sellerMicroGoalId}/product-conversion';

// remove negatives
export const GET_REMOVE_NEGATIVE_DYNAMIC_STATS = 'v2/store/analysis';
export const GET_REMOVE_NEGATIVE_REPORTS = 'v1/growz/microgoals/goal/dry/run/{sellerMicroGoalId}';
export const REMOVE_NEGATIVE_BY_TEXT = 'v2/growz/microgoals/{sellerMicroGoalId}/create/negative/keywords/by/text';
export const REMOVE_NEGATIVE_CONFIG_UPDATE = 'v2/growz/microgoals/{sellerMicroGoalId}/update/config';
export const REMOVE_NEGATIVE_EXCLUDE_KEYWORDS = 'v2/growz/microgoals/{sellerMicroGoalId}/manage/excludes';

// scouter
export const GET_SCOUTER_KEYWORDS_LIST = 'v1/growz/microgoals/goal/{sellerMicroGoalId}/keywords';

// audit report
export const GROWZ_AUDIT = 'v1/growz/reports/audit';
export const GROWZ_AUDIT_OVERVIEW = 'v1/growz/reports/store-overview';
export const GROWZ_AUDIT_FUNNEL = 'v1/growz/reports/funnel-data?days={days}';
export const GROWZ_AUDIT_ADTYPES = 'v1/growz/reports/ad-types-coverage';
export const GROWZ_AUDIT_ACCOUNT_STRUCTURE = 'v1/growz/reports/account-structure';
export const GROWZ_AUDIT_ADTYPES_KPI = 'v1/growz/reports/ad-types-kpi-data?campaignType={campaignType}';

// creatives
export const GROWZ_ALL_CREATIVES_LIST = '/v1/growz/creatives/list';
export const GROWZ_GET_STORES_SPOTLIGHT_LIST = 'v1/growz/creatives/store-spotlight';
export const GROWZ_CREATIVE_ASSETS = 'v1/growz/creatives/sb/store/assets';
export const GROWZ_CREATIVE_CREATE = '/v1/growz/creatives/create';
export const GROWZ_CREATIVE_DELETE = '/v1/growz/creatives/:creativeId/delete';
export const GROWZ_CREATIVE_LIST = '/v1/growz/creatives/list';
export const GROWZ_SB_ASSET_UPLOAD = 'v1/growz/creatives/sb/store/upload/asset/img';
export const GROWZ_SB_ASSET_UPLOAD_NEW = 'v1/growz/creatives/{campaignType}/store/upload/asset/{type}';
export const GROWZ_SD_CX_TARGET_RECOMMENDATION = 'v2/growz/recommendations/sd/cx/target/recommendations';
export const GROWZ_AUDIENCE_TAXONOMY = 'v2/growz/recommendations/audience/taxonomy';
export const GROWZ_AUDIENCE_DISCOVERY = 'v2/growz/recommendations/audience/discovery';

// notifications
export const NOTIFICATIONS_GET = 'v1/system/notifications';
export const NOTIFICATIONS_POST = 'v1/system/notifications';

// marketplace
export const USER_MARKETPLACES_LIST = '/user/marketplaces/list';

// aisle dominator
export const AISLE_DOMINATOR_SELECTED_KEYWORDS = 'v1/aisle/process/selected/Keywords';
export const AISLE_DOMINATOR_LAUNCH = 'v1/aisle/process/launch';
export const AISLE_LIST_ALL = 'v1/aisle/all';
export const AISLE_DASHBOARD = 'v1/aisle/get/dashboard';
export const AISLE_GET_REPORT = 'v1/aisle/get/{aisleId}/report/{key}';
export const AISLE_GET_RESULT = 'v1/aisle/get/{aisleId}/result';
export const AISLE_GET_META = 'v1/aisle/get/{aisleId}/meta';
export const AISLE_BRANDED_KEYWORD = 'v1/growz/keywords/get/own/brand/keywords';
export const AISLE_HERO_KEYWORD = 'v1/growz/keywords/get/hero/keywords';
export const AISLE_ACTIVITY = 'v1/aisle/get/:aisleId/activity';
export const AISLE_ACTIVITY_BY_DATE = 'v1/aisle/get/:aisleId/activity/:date';
export const GET_AISLE_PAYMENTS = 'v1/aisle/plan/api';
export const GET_AISLE_LIVE_TIMELINE = 'v1/aisle/get/live/preview';
export const EDIT_AISLE = 'v1/aisle//edit/aisle/{aisleId}';
export const DELETE_AISLE = 'v1/aisle/delete/{aisleId}';

// Anaylyze
export const GET_CAMPAIGN_ANALYSIS = 'v1/growz/campaigns/analyze/all';

// Orders & Sales Metrics
export const GET_ORDERS_SALES_METRICS = 'v2/growz/orders/sales/metrics';

// Payment
export const CREATE_STRIPE_SESSION = 'v2/payments/create-portal-session';
export const GET_AISLE_BRANDS_PLANS = 'v2/payments/aisleBrand/plans';
export const GET_AISLE_PPC_PLANS = 'v2/payments/aislePPC/plans';
export const GET_GROWZ_PLANS = 'v2/payments/growz/plans';
export const GET_GROWZ_AUTOPILOT_PLANS = 'v2/payments/autopilot/plans';
export const PAYMENTS_GROWZ_START_TRIAL = 'v2/payments/growz/start-trial';
export const PAYMENTS_GROWZ_SUBSCRIBE = 'v2/payments/growz/subscribe';
export const PAYMENT_CHECKOUT = 'v2/payments/checkout';
export const GET_BILLING_DETAILS = 'v2/payments/billing';
export const GET_PRODUCT_DETAILS = 'v2/payments/product';
export const UPGRADE_PAYMENT_PLAN = 'v2/payments/billing-portal-url';
export const ORGANIZATION_UPDATE = 'v2/payments/org-update';

// account settings
export const CHANGE_PASSWORD = 'v2/user/change-password';

// AutoPilot
export const AUTOPILOT_CONFIG_POST = 'v2/growz/campaigns/{campaignId}/autopilot';

// rank tracker
export const RANK_TRACKER_GET = 'v2/growz/rank-tracker';
export const RANK_TRACKER_GET_PRODUCTS = 'v2/growz/rank-tracker/autocomplete/products';
export const RANK_TRACKER_CREATE = 'v2/growz/rank-tracker';
export const RANK_TRACKER_DELETE = 'v2/growz/rank-tracker/{trackerId}';
export const RANK_TRACKER_ADD_KEYWORDS = 'v2/growz/rank-tracker/{trackerId}/keywords';
export const RANK_TRACKER_REMOVE_KEYWORDS = 'v2/growz/rank-tracker/{trackerId}/keywords';
export const RANK_TRACKER_ASIN_GRAPH = 'v2/growz/rank-tracker/widget/metrics/{asin}';
export const RANK_TRACKER_GET_KEYWORDS_BY_ASIN = 'v2/growz/rank-tracker/{trackerId}';
export const RANK_TRACKER_ASIN_RANKING = 'v2/growz/rank-tracker/dashboard/{trackerId}/widgets';
export const RANK_TRACKER_GET_WIDGETS = 'v2/growz/rank-tracker/dashboard/widgets';
export const RANK_TRACKER_GET_SUGGESTED_KEYWORDS = 'v2/growz/rank-tracker/autocomplete/keywords';

// Payments
export const CHARGEBEE_AUTOPILOT_CHECKOUT = 'v2/payments/checkout';
export const CHARGEBEE_PORTAL_SESSION = 'v2/payments/portal/session';
export const CHARGEBEE_INVOICES = 'v2/payments/invoices';
export const CHARGEBEE_DOWNLOAD_INVOICES = 'v2/payments/invoice/{invoiceId}/download';
export const ADDONS_CHECKOUT = 'v2/payments/addon/checkout';
export const ADDONS_UNSUBSCRIBE = 'v2/payments/addon/unsubscribe';
export const SUBSCRIPTION_UNSUBSCRIBE = 'v2/payments/subscription/unsubscribe';

// Reports
export const REPORTS_GET_CAMPAIGN_REPORT = 'v2/growz/reports/campaign-report';
export const REPORTS_GET_TOP_PERFORMING_CAMPAIGNS = 'v2/growz/reports/top-performing-campaigns';
export const REPORTS_GET_KEYWORD_REPORTS_BY_MATCHTYPE = 'v2/growz/reports/keywords-report-by-match-type';
export const REPORTS_GET_KEYWORD_PERFORMANCE_REPORTS = 'v2/growz/reports/get-keyword-performace-report';
export const REPORTS_GET_CAMPAIGN_PLACEMENT_REPORT_BY_POSITION = 'v2/growz/reports/campaign-report-by-placement-position';
export const REPORTS_GET_CAMPAIGN_BUDGET_UTILIZATION = 'v2/growz/reports/get-campaign-budget-utilization';
export const REPORTS_GET_STORE_SEARCH_TERM_REPORT = 'v2/growz/reports/get-store-searchTerm-Report';
export const REPORTS_GET_AUDIT_ADS_SUMMARY_REPORT = 'v2/growz/reports/audit-amazon-ads-report';
export const REPORTS_GET_AUDIT_CAMPAIGN_REPORT = 'v2/growz/reports/audit-campaign-ads-report';
export const REPORTS_GET_AUDIT_KEYWORDS_REPORT = 'v2/growz/reports/audit-keyword-analysis-report';
export const AUDIT_REPORTS_DOWNLOAD =
  'v2/growz/reports/download/audit-report?startDate={startDate}&endDate={endDate}&type={type}&accessId={accessId}';
export const WEEKLY_REPORTS_DOWNLOAD =
  'v2/growz/reports/download/weekly-performance?startDate={startDate}&endDate={endDate}&type={type}&accessId={accessId}';

// subscription
export const SUBSCRIPTION_REQUEST_QUOTE = 'v2/store/request/quote';
export const SUBSCRIPTION_ADD_ONS = 'v2/payments/growz/addons';
export const GROWZ_ASIN_SP_STRUCTURE = 'v2/growz/asin-analyzer/asin/ad/sp/structure';
export const GROWZ_ASIN_SD_STRUCTURE = 'v2/growz/asin-analyzer/asin/ad/sd/structure';
export const GROWZ_ASIN_SB_DETAILS = 'v2/growz/asin-analyzer/asin/sb/details';
export const GROWZ_POST_SP_ASIN_STRUCTURE_FIX_PREVIEW = 'v2/growz/asin-analyzer/asin/ad/sp/structure/fix/preview';
export const GROWZ_POST_SB_ASIN_STRUCTURE_FIX_PREVIEW = 'v2/growz/asin-analyzer/asin/ad/sb/custom/structure/fix/preview';
export const GROWZ_POST_SD_ASIN_STRUCTURE_FIX_PREVIEW = 'v2/growz/asin-analyzer/asin/ad/sd/structure/fix/preview';
export const GROWZ_POST_ASIN_SP_STRUCTURE_FIX = 'v2/growz/asin-analyzer/asin/ad/sp/structure/fix';
export const GROWZ_POST_ASIN_SD_STRUCTURE_FIX = 'v2/growz/asin-analyzer/asin/ad/sd/structure/fix';
export const GROWZ_POST_ASIN_SB_STRUCTURE_FIX = 'v2/growz/asin-analyzer/asin/ad/sb/structure/fix';
export const GROWZ_POST_NEW_SB_ASIN_LAUNCH = 'v2/growz/creatives/new/asin/launch';
export const GROWZ_GET_NEW_SB_ASIN_LAUNCH = 'v2/growz/asin-analyzer/asin/new/sb/launch';
export const GROWZ_GET_ASIN_STRUCTURE_SP_FIXES = 'v2/growz/asin-analyzer/get/asin/ad/sp/structure/fixes';
export const GROWZ_GET_ASIN_STRUCTURE_SD_FIXES = 'v2/growz/asin-analyzer/get/asin/ad/sd/structure/fixes';
export const GROWZ_GET_ASIN_STRUCTURE_SB_FIXES = 'v2/growz/asin-analyzer/get/asin/ad/sb/structure/fixes';
export const GROWZ_GET_ASIN_STRUCTURE_FIX_FOR_ASINS = 'v2/growz/asin-analyzer/asin/ad/structure/fixes/for/asins';
export const GROWZ_GET_ASIN_SEARCHTERMS = 'v2/growz/asin-analyzer/asin/ads/asin/searchTerms';
export const GROWZ_GET_ASIN_ANALYZER_SETTINGS = 'v2/growz/asin-analyzer/global-settings';
export const GROWZ_POST_ASIN_ANALYZER_SETTINGS = 'v2/growz/asin-analyzer/global-settings';

export const GROWZ_LIST_CREATIVES_AND_SBADS = 'v2/growz/creatives/list/sb/ads';
export const GROWZ_POST_ADD_CREATIVE_TO_NEW_SB = 'v2/growz/creatives/add/sb/creative';

export const GROWZ_KEYWORDS_ANALYZER = 'v2/growz/productad/asin/:asin/:type';
export const ADD_KEYWORDS_TO_ADGROUP = 'v2/growz/keywords/adGroup/add/keyword';

export const ADD_PRODUCTS_TO_ADGROUP = 'v2/growz/adgroups/{adGroupId}/productad';

// market stream
export const MARKET_STREAM_GET_CAMPAIGNS = 'v2/growz/marketing-stream/get/campaigns';
export const MARKET_STREAM_LAUNCH = 'v2/growz/marketing-stream/create/campaign/automation';
export const MARKET_STREAM_LAUNCHED = 'v2/growz/marketing-stream/get/campaigns/automations';
export const MARKET_STREAM_SUMMARY = 'v2/growz/marketing-stream/get/ams/summary';
export const MARKET_STREAM_UPDATE = 'v2/growz/marketing-stream/update/automation/{gmsAutomationId}';
export const MARKET_STREAM_BY_CAMPAIGN_ID = 'v2/growz/marketing-stream/get/campaign/{campaignId}/automations';
export const MARKET_STREAM_STATS_BY_DAY = 'v2/growz/marketing-stream/get/ams/summary/by/day';
export const MARKET_STREAM_STATS_BY_CAMPAIGN_ID = 'v2/growz/marketing-stream/get/ams/summary/{campaignId}/by/day';
export const MARKET_STREAM_SUMMARY_BY_CAMPAIGN = 'v2/growz/marketing-stream/get/ams/summary/{campaignId}';
export const MARKET_STREAM_ACTION_LOGS = '/v2/growz/marketing-stream/get/gms/{ruleId}/{actionId}/logs';
export const MARKET_STREAM_BY_SLOTS_STATS = 'v2/growz/marketing-stream/get/ams/summary/by/slot';
export const MARKET_STREAM_SLOTS_STATS_BY_CAMPAIGN_ID = 'v2/growz/marketing-stream/get/ams/summary/{campaignId}/by/slot';
export const MARKET_STREAM_LAUNCHED_REPORTS = 'v2/growz/reports/market-stream-report?streamId={streamId}&rule={ruleId}';

// notification and alerts
export const GET_ALL_NOTIFICATIONS = 'v2/alert-notification/alerts';
export const ALERTS_QUICK_TASK_DATA = 'v2/alert-notification/alerts/get/quick/task/data';
export const ALERTS_POST_READ_STATUS = 'v2/alert-notification/alerts/read';

// account health
export const ACCOUNT_HEALTH_OVERVIEW = 'v2/store/health/overview';
export const ACCOUNT_HEALTH_PRODUCTS_PERFORMANCE = 'v2/store/health/products';

// strategy
export const STRATEGY_INPUTS_BY_SLUG = 'v2/growz/microgoals/details/{strategySlug}';

// push notifications
export const PUSH_NOTIFICATION_POST_TOKEN = 'v2/user/register/push-notification?userId={userId}';
